<template>
  <v-window class="mb-4">
    <v-img src="/image/godfather/bg.jpg"
           id="landing-section">
      <v-layout row
                style="height:100%">

        <v-layout align-center
                  justify-center>
          <v-flex xs12>
            <v-card color="transparent"
                    flat>
              <v-card-text>
                <h3 id="slogan"
                    class="text-xs-center white--text text-shadow">
                  {{ $t('site.godfather.slogan')}}
                </h3>
                <h4 id="subslogan"
                    class="text-xs-center white--text text-shadow mt-3">
                  {{ $t('site.godfather.subslogan', { registerGift: registerGift }) }}
                </h4>
                <v-layout class="justify-center">
                  <v-flex class="xs12 md6 text-xs-center">
                    <v-btn color="accent"
                           round
                           large
                           class="white--text initialize font-weight-bold mt-5"
                           v-html="$t('site.godfather.button')"></v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <div id="landing-section-bottom">
          <download-app></download-app>
        </div>
      </v-layout>
    </v-img>

    <template>
      <div v-waypoint="{ active: true, callback: onWaypoint }"></div>
    </template>

    <h1 class="mt-5 text-xs-center primary--text"
        v-html="$t('site.godfather.title')">
    </h1>

    <v-layout row
              wrap
              justify-space-around>
      <template v-for="(item, index) in firstLine">
        <v-flex :key="item.index"
                xs12
                sm6
                md3
                :class="{ 'ma-4' : $vuetify.breakpoint.xsOnly }">
          <v-card height="100%"
                  flat>

            <v-img :src="item.image"
                   min-height="471px"
                   aspect-ratio="2.75">
            </v-img>

            <v-card-text>
              <v-layout row>
                <v-flex xs1
                        class="accent--text stepNumber">
                  {{ index + 1}}</v-flex>
                <v-flex xs11>
                  {{ item.text }}
                </v-flex>
              </v-layout>
            </v-card-text>

          </v-card>
        </v-flex>
      </template>
    </v-layout>

    <v-layout row
              wrap
              justify-space-around>
      <template v-for="(item, index) in secondLine">
        <v-flex :key="item.index"
                xs12
                sm6
                md3
                :class="{ 'ma-4' : $vuetify.breakpoint.xsOnly }">
          <v-card height="100%"
                  flat>

            <v-img :src="item.image"
                   min-height="471px"
                   aspect-ratio="2.75">
            </v-img>

            <v-card-text>
              <v-layout row>
                <v-flex xs1
                        class="accent--text stepNumber">
                  {{ index + 4}}</v-flex>
                <v-flex xs11>
                  {{ item.text }}
                </v-flex>
              </v-layout>
            </v-card-text>

          </v-card>
        </v-flex>
      </template>
    </v-layout>

  </v-window>
</template>

<script>
import DownloadApp from '@/components/commons/DownloadApp';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import store from '@/store';
import utilService from '@/services/utilService'

export default {
  name: 'GodfatherPage',
  components: {
    [DownloadApp.name]: DownloadApp
  },
  computed: {
    registerGift() {
      let price = store.state.countrySelected.prices.register;
      return this.$options.filters.addCurrencySymbol(price);
    }
  },
  metaInfo() {
    return {
      title: this.$i18n.t('page.title'),
      meta: [
        {
          name: 'description',
          content: this.$i18n.t('page.description')
        },
        {
          name: 'apple-itunes-app',
          content: 'app-id=573568924'
        },
        {
          name: 'keywords',
          content: this.$i18n.t('page.keywords')
        },
        {
          property: 'twitter:title',
          content: this.$i18n.t('meta.twitter.title')
        },
        {
          property: 'twitter:card',
          content: 'photo'
        },
        {
          property: 'twitter:site',
          content: this.twitterHashtag
        },
        {
          property: 'twitter:image',
          content: utilService.getSharedLogo()
        },
        {
          property: 'twitter:url',
          content: window.location.href
        },
        {
          property: 'og:title',
          content: this.$i18n.t('meta.og.title')
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          property: 'og:site_name',
          content: 'wesmartPark'
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:description',
          content: this.$i18n.t('meta.og.description')
        },
        {
          property: 'og:image',
          content: utilService.getSharedLogo()
        },
        {
          property: 'og:image:secure_url',
          content: utilService.getSharedLogo()
        },
        {
          property: 'og:image:alt',
          content: this.$i18n.t('meta.og.image')
        },
        {
          property: 'og:image:width',
          content: '1200'
        },
        {
          property: 'og:image:height',
          content: '586'
        },
        {
          property: 'og:image:type',
          content: 'image/jpeg'
        }
      ]
    };
  },
  data() {
    return {
      langSelected: store.state.langSelected,
      firstLine: [],
      secondLine: []
    };
  },
  created() {
    this.loadSteps();
    EventBus.$on(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  methods: {
    changeLanguage(params) {
      this.langSelected = store.state.langSelected;
      this.loadSteps();
    },
    onWaypoint({ going, direction, el }) {
      if (going === this.$waypointMap.GOING_IN) {
        EventBus.$emit(keys.eventShowToolbar, { offset: el.offsetTop });
      }
    },
    loadSteps() {
      this.firstLine = [
        {
          image: `/image/godfather/${this.langSelected.lang}/step1.gif`,
          text: this.$i18n.t('site.godfather.point1')
        },
        {
          image: `/image/godfather/${this.langSelected.lang}/step2.gif`,
          text: this.$i18n.t('site.godfather.point2')
        },
        {
          image: `/image/godfather/${this.langSelected.lang}/step3.gif`,
          text: this.$i18n.t('site.godfather.point3')
        }
      ];
      this.secondLine = [
        {
          image: `/image/godfather/${this.langSelected.lang}/step4.gif`,
          text: this.$i18n.t('site.godfather.point4')
        },
        {
          image: `/image/godfather/${this.langSelected.lang}/step5.gif`,
          text: this.$i18n.t('site.godfather.point5', { registerGift: this.registerGift })
        },
        {
          image: `/image/godfather/${this.langSelected.lang}/step6.gif`,
          text: this.$i18n.t('site.godfather.point6')
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
#landing-section {
  height: calc(100vh);
}
#landing-section #slogan {
  font-weight: bold;
}
.xs #landing-section #slogan {
  font-size: 6vh;
  line-height: 6vh;
}
.sm #landing-section #slogan {
  font-size: 6vh;
  line-height: 6vh;
}
.md #landing-section #slogan {
  font-size: 6vh;
  line-height: 6vh;
}
.lg #landing-section #slogan {
  font-size: 7vh;
  line-height: 7vh;
}

.xs #landing-section #subslogan {
  font-size: 2vh;
  line-height: 2vh;
}
.sm #landing-section #subslogan {
  font-size: 3vh;
  line-height: 3vh;
}
.md #landing-section #subslogan {
  font-size: 3vh;
  line-height: 3vh;
}
.lg #landing-section #subslogan {
  font-size: 4vh;
  line-height: 4vh;
}

#landing-section #landing-section-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
}
#landing-section .v-card {
  margin-top: -10%;
}
.stepNumber {
  font-size: 2em;
  font-weight: 600;
  min-width: 1em;
  display: inline-block;
}
</style>
